const properties = {
  system_code: 'IBU-OWT-CORE',
  platform_type: 'Web',
  platform_name: 'OWT',
  product_code: 'OWT',
}

export default properties
